import { ContentType } from '@/@types/common'
import { closeWebview, openWebview } from '@ruguoapp/jike-js-sdk'
import { getEnv } from '@ruguoapp/jkfe-env'
import { MakeRouteMatchUnion } from '@tanstack/react-router'
import { last } from 'lodash-es'
import { toJikeURLScheme } from './jikeURLScheme'

export function checkBrowserEnv() {
	const regexStr = import.meta.env.VITE_SUPPORTED_BROWSERS_REGEXP.replace(/^\/|\/$/g, '')
	const supportedBrowserReg = new RegExp(regexStr)

	return supportedBrowserReg.test(navigator.userAgent)
}

const env = getEnv()
export const isInJikeApp = env.app.isJike

export function checkIsInJikeApp(matches: MakeRouteMatchUnion[]) {
	const params = last(matches)?.params as
		| {
				type: 'post' | 'repost'
				id: string
				commentId?: string
		  }
		| undefined

	if (!isInJikeApp || !params) {
		return
	}

	let scheme: string | null = null

	if (params.commentId) {
		scheme = toJikeURLScheme({
			type: 'COMMENT',
			id: params.commentId,
			targetId: params.id,
			targetType: params.type === 'post' ? ContentType.POST : ContentType.REPOST,
		})
	} else {
		if (params.type === 'post') {
			scheme = toJikeURLScheme({ type: 'ORIGINAL_POST', id: params.id })
		} else if (params.type === 'repost') {
			scheme = toJikeURLScheme({ type: 'REPOST', id: params.id })
		}
	}

	if (!scheme) {
		return
	}

	openWebview(scheme)
	closeWebview()
}
